"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importDefault(require("react"));
var DesktopProviders_1 = __importDefault(require("./DesktopProviders"));
var MobileProviders_1 = __importDefault(require("./MobileProviders"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Providers = function () {
    var data = (0, swr_hooks_1.useProviders)().data;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    if (!data)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && react_1.default.createElement(DesktopProviders_1.default, { providers: data }),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(MobileProviders_1.default, { providers: data }))));
};
exports.default = Providers;
